import useAnalyticsContext from './useAnalyticsContext';

const useCard = (identifier: string) => {
  const { cards } = useAnalyticsContext();
  return cards.find(c => c.identifier === identifier) || {};
};

export default useCard;
